import React from 'react';
import styled from 'styled-components';

import CapitalizedButton from '@modules/custom-grouping/components/common/CapitalizedButton';
import { IEnrollmentDetails } from './enrollmentHistoryTypes';

interface StylesCenterItemProps {
    className?: string; // Allow className prop
    children?: React.ReactNode; // Ensure children prop is valid
}
const StylesCenterItem = styled.div<StylesCenterItemProps>`
    text-align: center;
    .gi-button__secondary {
        width: 100%;
    }
`;

const PlanBenefits = (props: { enrollmentDetails: IEnrollmentDetails }) => {
    const { enrollmentDetails } = { ...props };
    const planDetailsUrl = `/hix${enrollmentDetails.benefitDetailsUrl}`;
    const handleViewBenefitsClick = () => {
        // Setting session storage values similar to SideNavContainer.tsx
        const sessionStorageObject = {
            idmUserStatus: sessionStorage.getItem('idmUserStatus'),
            userStatus: sessionStorage.getItem('userStatus'),
            hhUserId: sessionStorage.getItem('householdUserId'),
            hhFirstName: sessionStorage.getItem('householdFirstName'),
            hhLastName: sessionStorage.getItem('householdLastName'),
            encHHId: sessionStorage.getItem('encHouseHoldId'),
            hhId: sessionStorage.getItem('householdId') || '',
            hhUser: sessionStorage.getItem('householdUser'),
            calheersEnv: sessionStorage.getItem('calheersEnv'),
            addNewViewCaseUrl: sessionStorage.getItem('addNewViewCaseUrl'),
            checkDilog: sessionStorage.getItem('checkDilog'),
            permissionMap: sessionStorage.getItem('permissionMap'),
            switchToModuleName: sessionStorage.getItem('switchToModuleName'),
            hhEmail: sessionStorage.getItem('householdEmail'),
            hhPhone: sessionStorage.getItem('householdPhone'),
            hhUserStatus: sessionStorage.getItem('householdUserStatus'),
        };

        sessionStorage.setItem('selectedPlanDetails', JSON.stringify(sessionStorageObject));
        localStorage.setItem('HK_encHouseholdId', sessionStorageObject.encHHId || '');

        // Open in a new tab
        window.open(planDetailsUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <StylesCenterItem className="col-xs-12 col-md-6 col-lg-6">
            <img alt="logo" src={enrollmentDetails.planLogoUrl}></img>
            <p>
                <span className="link-text"> {enrollmentDetails.planName}</span>
            </p>
            <CapitalizedButton
                id="viewBenefitDetailsBtn"
                dataTestId="viewBenefitDetailsBtn"
                variant="secondary"
                labelId="indportal.enrollments.viewBenefitDetails"
                onClickHandler={handleViewBenefitsClick}
            />
        </StylesCenterItem>
    );
};

export default PlanBenefits;
